var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmployeeOutside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.905 15.75H1.155V16.875H16.905V15.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 1.125L4.7325 1.92L3.2775 3.375H7.875V4.5H3.2775L4.7325 5.955L3.9375 6.75L1.125 3.9375L3.9375 1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.945 5.6325C15.6375 4.4325 14.6625 3.5175 13.455 3.3V2.535H12.375V3.3C11.16 3.5175 10.185 4.425 9.885 5.6325H9.435V6.7125H10.26C10.3125 8.13 11.4825 9.27 12.915 9.27C14.3475 9.27 15.5175 8.13 15.57 6.7125H16.395V5.6325H15.945ZM14.49 6.7125C14.4375 7.5375 13.7475 8.19 12.915 8.19C12.0825 8.19 11.3925 7.5375 11.34 6.7125H14.49ZM13.455 5.0325V4.4025C14.0625 4.575 14.565 5.0325 14.805 5.6325H11.025C11.265 5.0325 11.7675 4.575 12.375 4.4025V5.0325H13.455Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0925 10.2H11.73C10.1775 10.2 8.9175 11.46 8.9175 13.0125V14.7075H10.0425V13.0125C10.0425 12.465 10.305 11.985 10.71 11.6775V14.7075H11.835V11.325H13.98V14.7075H15.105V11.6775C15.51 11.985 15.7725 12.465 15.7725 13.0125V14.7075H16.8975V13.0125C16.8975 11.46 15.6375 10.2 14.085 10.2H14.0925Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmployeeOutside);
export default __webpack_public_path__ + "static/media/ic-employee-outside.7c3940c68addf07eb73f5d7266bd6fd3.svg";
export { ForwardRef as ReactComponent };